<template>
  <div class="exercise_list_edit" data-testid="exercise_list_edit">
    <v-list
      v-if="exercises && all_video_exercises"
      two-line
      subheader
      :dense="dense"
      :class="show_add_actions ? 'pb-12' : 'py-0'"
    >
      <draggable
        v-model="localValue"
        :disabled="readonly"
        @end="drag_end"
        direction="vertical"
        :key="localValue.length"
        force-fallback="true"
        :filter="'.no-drag'"
      >
        <div
          v-for="(item, index) in localValue"
          :key="item.uuid"
          :data-exercise-type="item.exercise_type"
        >
          <div :class="(dense ? 'pb-0' : 'pb-1') + ' exercise-list-item-wrap'">
          <v-sheet
            outlined
            :rounded="dense ? false : true"
            style="cursor: move; cursor: grab; user-select: none;"
            class="exercise-list-item"
          >
            <v-list-item :dense="dense" :style="dense ? 'min-height: 56px;' : ''">
              <v-badge
                v-if="item.exercise_type == 'grid_sequence' || item.exercise_type == 'grid_schedule'"
                class="exercise-list-avatar-badge"
                v-bind="container_index_badge(item)"
                overlap
                small
                bottom
                offset-y="30"
                offset-x="30"
                color="grey"
              >
                <v-list-item-avatar>
                  <v-icon
                    v-if="item.exercise_type == 'grid_sequence'"
                    class="grey lighten-1 white--text"
                  >
                    mdi-source-branch
                  </v-icon>
                  <v-icon v-else class="grey lighten-1 white--text">
                    fas fa-border-all
                  </v-icon>
                </v-list-item-avatar>
              </v-badge>
              <v-list-item-avatar v-else :style="dense ? 'margin-top: 0px; margin-bottom: 0px;' : ''">
                <v-icon
                  v-if="
                    exercises[item.exercise_id] &&
                    exercises[item.exercise_id].group.length &&
                    (item.exercise_type == 'interactive' || !item.exercise_type)
                  "
                  class="grey lighten-1 white--text"
                  >
                    {{ icons[exercises[item.exercise_id].group[0]] }}
                  </v-icon>

                <v-icon
                  v-else-if="item.exercise_type == 'custom' && item.group"
                  class="grey lighten-1 white--text"
                  >
                    {{ icons[item.group[0]] }}
                  </v-icon>

                <v-icon
                  v-else-if="item.exercise_type == 'header'"
                  class="grey lighten-1 white--text"
                  >
                    fas fa-heading
                  </v-icon>

                <v-icon
                  v-else-if="item.exercise_type == 'questionnaire'"
                  class="grey lighten-1 white--text"
                  >
                    mdi-clipboard-list
                  </v-icon>

                <v-icon
                  v-else-if="item.exercise_type == 'question'"
                  class="grey lighten-1 white--text"
                  >
                    fas fa-question
                  </v-icon>

                <v-icon
                  v-else-if="item.exercise_type == 'assessment'"
                  class="grey lighten-1 white--text"
                  >
                    fas fa-clipboard-list
                  </v-icon>

                <v-icon
                  v-else-if="item.exercise_type == 'email'"
                  class="grey lighten-1 white--text"
                  >
                    email
                  </v-icon>

                <v-icon
                  v-else-if="item.exercise_type == 'grid_set'"
                  class="grey lighten-1 white--text"
                >
                  fas fa-align-justify
                </v-icon>

                <template
                  v-else-if="
                    all_video_exercises &&
                    item.exercise_type.startsWith('video')
                  "
                >
                  <v-icon
                    v-if="
                      all_video_exercises[item.exercise_id] &&
                      all_video_exercises[item.exercise_id].group.length
                    "
                    class="grey lighten-1 white--text"
                    >{{
                      icons[all_video_exercises[item.exercise_id].group[0]]
                    }}</v-icon>
                  <v-icon v-else class="grey lighten-1 white--text"
                    >
                      ondemand_video
                    </v-icon>
                </template>
              </v-list-item-avatar>
              <v-list-item-content :style="dense ? 'padding-top: 0px; padding-bottom: 0px;' : ''">
                <div v-if="item.exercise_type == 'interactive' || !item.exercise_type">
                  <v-list-item-title>{{ exercise_title(item) }}</v-list-item-title>
                  <v-list-item-subtitle style="white-space: pre-line; max-height: 40px">
                      {{ item.instructions }}
                    </v-list-item-subtitle>
                </div>
                <div v-else-if="item.exercise_type.startsWith('video')">
                  <div v-if="exercise_exists(item)">
                    <v-list-item-title>{{
                      exercise_title(item)
                    }}</v-list-item-title>
                  </div>
                  <v-list-item-title v-else style="font-style: italic">{{ $t("regimen_edit.video_exercise_deleted") }}</v-list-item-title>
                  <v-list-item-subtitle
                    style="white-space: pre-line; max-height: 40px"
                    >
                      {{ item.instructions }}
                    </v-list-item-subtitle>
                </div>
                <div v-else-if="item.exercise_type == 'custom'">
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                  <v-list-item-subtitle style="white-space: pre-line; max-height: 40px">
                      {{ $t("common.custom") }}
                    </v-list-item-subtitle>
                </div>
                <div v-else-if="item.exercise_type == 'header'">
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                  <v-list-item-subtitle style="white-space: pre-line; max-height: 40px">
                      {{ $t("common.header") }}
                    </v-list-item-subtitle>
                </div>
                <div v-else-if="item.exercise_type == 'questionnaire'">
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                  <v-list-item-subtitle style="white-space: pre-line; max-height: 40px">
                    {{ $t("common.questionnaire") }}
                  </v-list-item-subtitle>
                </div>
                <div v-else-if="item.exercise_type == 'question'">
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                  <v-list-item-subtitle style="white-space: pre-line; max-height: 40px">
                    {{ $t("common.single_question") }}
                  </v-list-item-subtitle>
                </div>
                <div v-else-if="item.exercise_type == 'assessment'">
                  <v-list-item-title>{{ assessment_title(item) }}</v-list-item-title>
                  <v-list-item-subtitle style="white-space: pre-line; max-height: 40px">
                    {{ $t("common.assessment") }}
                  </v-list-item-subtitle>
                </div>
                <div v-else-if="item.exercise_type == 'email'">
                  <v-list-item-title>{{ item.title || $t("common.email") }}</v-list-item-title>
                  <v-list-item-subtitle style="white-space: pre-line; max-height: 40px">
                    {{ item.instructions }}
                  </v-list-item-subtitle>
                </div>
                <div v-else-if="item.exercise_type == 'grid_sequence'">
                  <v-list-item-title v-if="exercise_exists(item)">{{ grid_sequence_title(item) }}</v-list-item-title>
                  <v-list-item-title v-else style="font-style: italic">{{ $t("regimen_edit.grid_sequence_deleted") }}</v-list-item-title>
                  <v-list-item-subtitle style="white-space: pre-line; max-height: 40px">
                    {{ $t("community_sharing.grid_sequence") }}
                  </v-list-item-subtitle>
                </div>
                <div v-else-if="item.exercise_type == 'grid_set'">
                  <v-list-item-title v-if="exercise_exists(item)">{{ grid_set_title(item) }}</v-list-item-title>
                  <v-list-item-title v-else style="font-style: italic">{{ $t("regimen_edit.grid_set_deleted") }}</v-list-item-title>
                  <v-list-item-subtitle>{{ $t("common.grid_set") }}</v-list-item-subtitle>
                </div>
                <div v-else-if="item.exercise_type == 'grid_schedule'">
                  <v-list-item-title v-if="exercise_exists(item)">{{ grid_schedule_title(item) }}</v-list-item-title>
                  <v-list-item-title v-else style="font-style: italic">{{ $t("regimen_edit.grid_schedule_deleted") }}</v-list-item-title>
                  <v-list-item-subtitle>{{ $t("common.grid_schedule") }}</v-list-item-subtitle>
                </div>
                <v-list-item-subtitle v-if="admin_show_ids" style="user-select: all">
                  <pre>{{ item.uuid }}</pre>
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action v-if="exercise_exists(item)" :style="dense ? 'margin-top: 0px; margin-bottom: 0px;' : ''">
                <ExercisePreviewButton
                  :exercise="item"
                  :class="'no-drag ' + ($vuetify.rtl ? 'ml-2' : 'mr-2')"
                  :fully_configured="false"
                  :additional_video_exercises="additional_video_exercises"
                />
              </v-list-item-action>

              <v-list-item-action v-if="!readonly">
                <v-tooltip top open-delay="500">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :class="'no-drag ' + ($vuetify.rtl ? 'ml-2' : 'mr-2')"
                      icon
                      outlined
                      :small="dense"
                      v-on="on"
                      @click.stop="$emit('edit', index)"
                      data-testid="exercise_list_edit_exercise_item"
                    >
                      <v-icon :small="dense" color="green">edit</v-icon>
                    </v-btn>
                  </template>
                  {{ $t("common.edit") }}
                </v-tooltip>
              </v-list-item-action>

              <v-list-item-action v-if="!readonly && exercise_exists(item)">
                <v-tooltip v-if="!is_container_exercise(item)" top open-delay="500">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :class="'no-drag ' + ($vuetify.rtl ? 'ml-n2' : 'mr-n2')"
                      icon
                      outlined
                      :small="dense"
                      v-on="on"
                      @click.stop="duplicate_item(item, index)"
                      data-testid="exercise_list_edit_duplicate_item"
                    >
                      <v-icon :small="dense" color="purple">mdi-content-duplicate</v-icon>
                    </v-btn>
                  </template>
                  {{ $t("common.duplicate") }}
                </v-tooltip>
                <v-tooltip v-else top open-delay="500">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :class="'no-drag ' + ($vuetify.rtl ? 'ml-n2' : 'mr-n2')"
                      icon
                      outlined
                      :small="dense"
                      :disabled="!container_current_exercises(item).length"
                      v-on="on"
                      @click.stop="import_container_exercises(index)"
                      data-testid="exercise_list_edit_import_grid_item"
                    >
                      <v-icon :small="dense" color="blue">mdi-import</v-icon>
                    </v-btn>
                  </template>
                  {{ $t("regimen_edit.import_grid_set") }}
                </v-tooltip>
              </v-list-item-action>

              <v-list-item-action v-if="!readonly">
                <v-tooltip top open-delay="500">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :class="'no-drag ' + ($vuetify.rtl ? 'ml-n1' : 'mr-n1')"
                      icon
                      outlined
                      :small="dense"
                      v-on="on"
                      @click.stop="delete_item(index)"
                      data-testid="exercise_list_edit_delete_item"
                    >
                      <v-icon :small="dense" color="red lighten-1">delete</v-icon>
                    </v-btn>
                  </template>
                  {{ $t("common.delete") }}
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
          </v-sheet>
          <div
            v-if="container_current_exercises(item).length"
            class="no-drag exercise-list-nested-current"
          >
            <ExerciseListEdit
              :value="container_current_exercises(item)"
              dense
              readonly
              :show_add_actions="false"
              :additional_video_exercises="additional_video_exercises"
            />
          </div>
          </div>
        </div>
      </draggable>
    </v-list>
    <div v-if="localValue.length == 0 && !readonly && show_add_actions">
      <h3>{{ $t("regimen_edit.click_icon_to_add_exercise") }}</h3>
    </div>
    <div
      v-if="!readonly && show_add_actions"
      style="height: 60px; position: relative;"
    >
      <v-fab-transition>
        <v-tooltip top open-delay="500">
          <template v-slot:activator="{ on }">
            <v-btn
              color="blue"
              dark
              absolute
              top
              :right="$vuetify.rtl ? false : true"
              :left="$vuetify.rtl ? true : false"
              fab
              v-on="on"
              @click="$emit('add', allowed_exercise_types)"
              data-testid="exercise_list_edit_add_new_exercise"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          {{ $t("common.add_exercise") }}
        </v-tooltip>
      </v-fab-transition>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapState } from "vuex";
import { category_icons } from "../lib/category";
import { currentContainerExercises } from "../lib/regimen_grid";
import ExercisePreviewButton from "./ExercisePreviewButton.vue";
import uuid from "uuid";

const GRID_SEQUENCE_REPORT_CONTEXT_FIELDS = [
  "grid_sequence_id",
  "grid_sequence_assignment_id",
  "grid_sequence_step_id",
  "grid_sequence_step_activation_id",
];

export default {
  name: "ExerciseListEdit",
  components: { draggable, ExercisePreviewButton },
  props: {
    value: {
      type: Array,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
    additional_video_exercises: {
      type: Object,
      default: () => {},
    },
    show_add_actions: {
      type: Boolean,
      default: true,
    },
    manage_items: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    allowed_exercise_types: {
      type: Array,
      default: () => ["interactive", "video", "custom", "header", "question", "questionnaire", "grid_sequence", "grid_set", "grid_schedule"],
    },
  },
  data() {
    return {
      icons: category_icons,
    };
  },
  computed: {
    ...mapState([
      "exercises",
      "video_exercises",
      "current_user",
      "grid_sets",
      "grid_schedules",
      "grid_sequences",
      "admin_show_ids",
    ]),
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit("input", localValue);
      },
    },
    all_video_exercises() {
      if (!this.additional_video_exercises) {
        return this.video_exercises;
      }

      // Deep clone
      let add_video_exercises = JSON.parse(
        JSON.stringify(this.additional_video_exercises)
      );

      if (this.video_exercises) {
        return Object.assign(add_video_exercises, this.video_exercises);
      } else {
        return add_video_exercises;
      }
    },
  },
  methods: {
    delete_item(index) {
      if (!this.manage_items) {
        this.$emit("delete", index);
        return;
      }
      this.localValue.splice(index, 1);
      this.$emit('input', this.localValue);
      this.$emit('deleted', index);
    },
    drag_end() {
      this.$emit('dragged');
    },
    exercise_exists(item) {
      if (item.exercise_type.startsWith("video")) {
        return this.all_video_exercises[item.exercise_id] !== undefined;
      } else if (item.exercise_type == "interactive" || !item.exercise_type) {
        return this.exercises[item.exercise_id] !== undefined;
      } else if (item.exercise_type == "grid_sequence") {
        return this.resolve_grid_sequence(item) !== null;
      } else if (item.exercise_type == "grid_set") {
        return this.resolve_grid_set(item) !== null;
      } else if (item.exercise_type == "grid_schedule") {
        return this.resolve_grid_schedule(item) !== null;
      } else {
        return true;
      }
    },
    duplicate_item(item, index) {
      if (["grid_sequence", "grid_set", "grid_schedule"].includes(item.exercise_type)) {
        return;
      }
      if (!this.manage_items) {
        this.$emit("duplicate", index);
        return;
      }
      let new_item = JSON.parse(JSON.stringify(item));

      new_item.uuid = uuid.v4();
      new_item.index = null;

      // Insert after the current item, by looking at index value 
      this.localValue.splice(index +1, 0, new_item);
    },
    drag_move() {
      if (this.readonly) {
        return false;
      }
      return true;
    },
    assessment_title(item) {
      let title = "";

      for (let grid_set of this.grid_sets) {
        if (item.assessment_id == grid_set.id) {
          title = grid_set.title;
          break;
        }
      }
      return title;
    },
    grid_sequence_title(item) {
      if (item.title) {
        return item.title;
      }
      const grid_sequence = this.resolve_grid_sequence(item);
      return grid_sequence ? grid_sequence.title : "";
    },
    grid_set_title(item) {
      if (item.title) return item.title;
      const gridSet = this.resolve_grid_set(item);
      return gridSet ? gridSet.title : "";
    },
    grid_schedule_title(item) {
      if (item.title) return item.title;
      const schedule = this.resolve_grid_schedule(item);
      return schedule ? schedule.title : "";
    },
    resolve_grid_set(item) {
      if (item.grid_set && item.grid_set.id === item.exercise_id) {
        return item.grid_set;
      }
      return (this.grid_sets || []).find((candidate) => candidate.id === item.exercise_id) || null;
    },
    resolve_grid_schedule(item) {
      if (item.grid_schedule && item.grid_schedule.id === item.exercise_id) {
        return item.grid_schedule;
      }
      return (this.grid_schedules || []).find((candidate) => candidate.id === item.exercise_id) || null;
    },
    resolve_grid_sequence(item) {
      if (item.grid_sequence && item.grid_sequence.id === item.exercise_id) {
        return item.grid_sequence;
      }
      return (this.grid_sequences || []).find((candidate) => candidate.id === item.exercise_id) || null;
    },
    resolved_container_assignment(item) {
      if (item.exercise_type === "grid_set") {
        const grid_set = this.resolve_grid_set(item);
        return grid_set ? { ...item, grid_set } : item;
      }
      if (item.exercise_type === "grid_schedule") {
        const grid_schedule = this.resolve_grid_schedule(item);
        if (!grid_schedule) return item;
        const stages = grid_schedule.grid || [];
        const currentStageExists = stages.some((stage) => stage.id === item.grid_current_stage);
        const grid_current_stage = currentStageExists
          ? item.grid_current_stage
          : ((stages[0] && stages[0].id) || null);
        return { ...item, grid_schedule, grid_current_stage };
      }
      if (item.exercise_type === "grid_sequence") {
        const grid_sequence = this.resolve_grid_sequence(item);
        return grid_sequence ? { ...item, grid_sequence } : item;
      }
      return item;
    },
    container_current_exercises(item) {
      if (!this.is_container_exercise(item)) return [];
      return currentContainerExercises(this.resolved_container_assignment(item));
    },
    /** 1-based week/step for the container's current selection, or null when none. */
    container_current_index(item) {
      const assignment = this.resolved_container_assignment(item);
      if (assignment.exercise_type === "grid_sequence") {
        const steps = (assignment.grid_sequence && assignment.grid_sequence.sequence) || [];
        if (!steps.length || assignment.active_step === "complete") return null;
        if (!assignment.active_step || assignment.active_step === "uninitialized") {
          return 1;
        }
        const index = steps.findIndex((step) => step.id === assignment.active_step);
        return index === -1 ? null : index + 1;
      }
      if (assignment.exercise_type === "grid_schedule") {
        const stages = (assignment.grid_schedule && assignment.grid_schedule.grid) || [];
        if (!stages.length || !assignment.grid_current_stage) return null;
        const index = stages.findIndex((stage) => stage.id === assignment.grid_current_stage);
        return index === -1 ? null : index + 1;
      }
      return null;
    },
    container_index_badge(item) {
      const index = this.container_current_index(item);
      return {
        content: index == null ? "" : String(index),
        value: index != null,
      };
    },
    is_container_exercise(item) {
      return ["grid_sequence", "grid_set", "grid_schedule"].includes(item.exercise_type);
    },
    exercise_title(item) {
      if (item.title) {
        return item.title;
      }
      let exercise;
      if (item.exercise_type.startsWith("video")) {
        exercise = this.all_video_exercises[item.exercise_id];
      } else {
        exercise = this.exercises[item.exercise_id];
      }

      let locale = this.$i18n.lang();

      let title;
      if (exercise.title[locale]) {
        title = exercise.title[locale];
      } else {
        title = exercise.title.en;
      }

      if (item.video_exercise_variant && item.config && item.config.variants) {
        let variant = item.config.variants[item.video_exercise_variant];
        title += ": " + this.variant_title(variant);
      }

      return title;
    },
    variant_title(variant) {
      let locale = this.$i18n.lang();
      if (!variant.title) {
        return "";
      }

      if (variant.title[locale]) {
        return variant.title[locale];
      } else if (variant.title.en) {
        return variant.title.en;
      } else {
        return "";
      }
    },
    container_title(item) {
      if (item.exercise_type === "grid_set") {
        return this.grid_set_title(item);
      }
      if (item.exercise_type === "grid_schedule") {
        return this.grid_schedule_title(item);
      }
      if (item.exercise_type === "grid_sequence") {
        return this.grid_sequence_title(item);
      }
      return item.title || "";
    },
    clone_imported_exercise(exercise) {
      const cloned = JSON.parse(JSON.stringify(exercise));
      cloned.uuid = uuid.v4();
      cloned.index = null;
      for (const field of GRID_SEQUENCE_REPORT_CONTEXT_FIELDS) {
        delete cloned[field];
      }
      return cloned;
    },
    /**
     * Replace an assigned grid container with a header plus its current
     * set / stage / step exercises.
     */
    import_container_exercises(index) {
      const item = this.localValue[index];
      if (!item || !this.is_container_exercise(item)) {
        return false;
      }

      const children = this.container_current_exercises(item);
      if (!children.length) {
        return false;
      }

      const header_exercise = {
        exercise_type: "header",
        title: this.container_title(item),
        instructions: "",
        uuid: uuid.v4(),
        index: null,
        config: {},
      };
      const imported = [
        header_exercise,
        ...children.map((exercise) => this.clone_imported_exercise(exercise)),
      ];

      if (!this.manage_items) {
        const next = [...this.localValue];
        next.splice(index, 1, ...imported);
        this.$emit("input", next);
        this.$emit("dragged");
        return true;
      }

      this.localValue.splice(index, 1, ...imported);
      this.$emit("input", this.localValue);
      this.$emit("dragged");
      return true;
    },
  },
};
</script>

<style>

.exercise_list_edit div[data-exercise-type="header"] ~ div:not([data-exercise-type="header"]) {
  margin-left: 20px;
}

.exercise_list_edit .exercise-list-nested-current {
  margin-left: 20px;
}

.exercise-list-avatar-badge {
  margin-left: -15px;
}

</style>
